import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { InfoIcon } from 'src/components/Icons/Info';
import { PlusSubscriptionUpgradeNowModalClose } from 'src/components/plusSubscription/modals/icons/Close';
import { UpsellPlanPreselectedActivateButton } from 'src/components/plusSubscription/modals/PlanPreselected/ActivateButton';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { BaseSeparateModal } from 'src/models/modals';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { PlusSubscriptionPlanPreselectedModalInfoSelector } from 'src/store/plusSubscription/selectors';
import { useTHelper } from 'src/utils/i18n';
import styles from './styles.module.scss';

type Props = BaseSeparateModal;

export const UpsellPlanPreselected: FC<Props> = ({ onClose }) => {
  const tHelper = useTHelper('upsellModals.planPreselected');

  const { Name } = useSelector(deCommonCurrentPartnerSelector);

  const modalInfo = useSelector(PlusSubscriptionPlanPreselectedModalInfoSelector);

  return (
    <UiModal onHide={onClose} noFooter modalClassName={styles.modal}>
      <button type="button" onClick={onClose} className={styles.close}>
        <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
      </button>

      <div className={styles.title}>{tHelper('title')}</div>

      <div className={styles.cards}>
        <div role="presentation" className={styles.card}>
          <h4 className={styles.cardTitle}>
            {tHelper('plan.title')}

            <span className={styles.radio} />
          </h4>

          <div className={styles.content}>
            <span className={styles.customFeature}>
              {tHelper('plan.subscription', {
                amount: modalInfo?.SubscriptionPeriodFee || 0,
                context: modalInfo?.SubscriptionPeriodMonthsCount === 12 ? 'yearly' : 'monthly',
              })}
              {tHelper('plan.percentFee', { percent: modalInfo?.PerTransactionFee || 0 })}
            </span>

            <span className={styles.customInfo}>{tHelper('plan.info.text1', { partnerName: Name })}</span>
            <span className={styles.customInfo}>{tHelper('plan.info.text2')}</span>
          </div>
        </div>
      </div>

      {modalInfo && (
        <UpsellPlanPreselectedActivateButton
          buttonText={tHelper('activateSubscription')}
          customerInfo={modalInfo.PlusSubscriptionCustomerInfo}
        />
      )}

      <div className={styles.info}>
        <InfoIcon className={styles.icon} />
        {tHelper('info')}
      </div>
    </UiModal>
  );
};
